module.exports = __webpack_public_path__ + "img/43.b6399795.png";